import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import { type IMediaService } from "@saif-reporting/domain/interfaces/services/IMediaService.js";

export class MediaService implements IMediaService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  // async getById(id: number): Promise<MediaDto> {
  //   return await this.api.$fetch<MediaDto>(`/media/${id}`);
  // }

  // async getReportImages(reportId: number): Promise<MediaDto[]> {
  //   return await this.api.$fetch<MediaDto[]>(`/media/report-images/${reportId}'`);
  // }

  // async saveReportImage(reportId: number, file: File): Promise<MediaDto> {
  //   const formdata = new FormData();
  //   formdata.append("reportId", reportId.toString());
  //   formdata.append("file", file);
  //   return await this.api.$fetch<MediaDto>(`/media/report-images/${reportId}`, { method: "post", body: formdata });
  // }

  // async deleteReportImage(reportId: number, imageId: number): Promise<MediaDto> {
  //   return await this.api.$fetch<MediaDto>(`/media/report-images/${reportId}/${imageId}`, { method: "delete" });
  // }

  // async getReportVideos(reportId: number): Promise<MediaDto[]> {
  //   return await this.api.$fetch<MediaDto[]>(`/media/report-videos/${reportId}'`);
  // }

  // async saveReportVideo(reportId: number, file: File): Promise<MediaDto> {
  //   const formdata = new FormData();
  //   formdata.append("reportId", reportId.toString());
  //   formdata.append("file", file);
  //   return await this.api.$fetch<MediaDto>(`/media/report-videos/${reportId}`, { method: "post", body: formdata });
  // }

  // async deleteReportVideo(reportId: number, videoId: number): Promise<MediaDto> {
  //   return await this.api.$fetch<MediaDto>(`/media/report-videos/${reportId}/${videoId}`, { method: "delete" });
  // }
}
